import { config } from '@/config';
export class MaestrosService {
    // 1. Estados, Municipios y Parroquias (Jerarquía en cascada)
    static async getEstados() {
        const response = await fetch(`${config.API_URL}/api/Estado`);
        if (!response.ok)
            throw new Error("Error al obtener estados");
        return response.json();
    }
    static async getMunicipiosByEstado(estadoId) {
        const response = await fetch(`${config.API_URL}/api/Municipio/estado/${estadoId}`);
        if (!response.ok)
            throw new Error("Error al obtener municipios");
        return response.json();
    }
    static async getParroquiasByMunicipio(municipioId) {
        const response = await fetch(`${config.API_URL}/api/Parroquia/municipio/${municipioId}`);
        if (!response.ok)
            throw new Error("Error al obtener parroquias");
        return response.json();
    }
    // 2. Datos Fiscales y de Documentación
    static async getTiposDocumento() {
        const response = await fetch(`${config.API_URL}/api/TipoDocumento`);
        if (!response.ok)
            throw new Error("Error al obtener tipos de documento");
        return response.json();
    }
    static async getTiposContribuyente() {
        const response = await fetch(`${config.API_URL}/api/TipoContribuyente`);
        if (!response.ok)
            throw new Error("Error al obtener tipos de contribuyente");
        return response.json();
    }
    // 3. Tipo de Comercio (Detal, Mayorista, etc.)
    static async getTiposComercio() {
        const response = await fetch(`${config.API_URL}/api/TipoComercio`);
        if (!response.ok)
            throw new Error("Error al obtener tipos de comercio");
        return response.json();
    }
    // 4. Departamentos y Categorías
    static async getDepartamentos() {
        const response = await fetch(`${config.API_URL}/api/Departamento`);
        if (!response.ok)
            throw new Error("Error al obtener departamentos");
        return response.json();
    }
    static async getCategorias() {
        const response = await fetch(`${config.API_URL}/api/Categoria`);
        if (!response.ok)
            throw new Error("Error al obtener categorías");
        return response.json();
    }
}
